import { render, staticRenderFns } from "./BeaconReader.vue?vue&type=template&id=7aed38a2&scoped=true&"
import script from "./BeaconReader.vue?vue&type=script&lang=js&"
export * from "./BeaconReader.vue?vue&type=script&lang=js&"
import style0 from "./BeaconReader.vue?vue&type=style&index=0&id=7aed38a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aed38a2",
  null
  
)

export default component.exports